SidebarKo = App.loadClass 'core::viewmodels/filters/Sidebar'

class exports.Keyfields_Handler extends Handler
    constructor: (@modalInstance) ->
        super

    init: () ->
        @layoutUrl = 'backend/portal/keyfields/'
        @subHandlers =
            'Keyfields':
                'class': 'portal::handlers/keyfields/Keyfields_SubHandler'

        @defaultSub = 'Keyfields'
        @loadLayout()


    afterLoadLayout: (selector, data) ->
        filters = [
            {
                name: 'Region Filters',
                filters: [
                    {
                        name: 'years'
                        display_name: 'Year'
                        control_type: 'single_dropdown'
                    },
                    {
                        name: 'states'
                        display_name: 'State'
                    },
                    {
                        name: 'zones'
                        display_name: 'Zone'
                    },
                    {
                        name: 'zips'
                        display_name: 'ZIP Code'
                    }
                ],
            },
            {
                name: 'Operation Filters',
                filters: [
                    {
                        name: 'companies'
                        display_name: 'Company'
                    },
                    {
                        name: 'owners'
                        display_name: 'User'
                    },
                    {
                        name: 'farms'
                        display_name: 'Farm'
                        class: 'dropup'
                    },
                    {
                        name: 'fields'
                        display_name: 'Field'
                        class: 'dropup'
                    }
                ]
            },
            {
                name: 'Key Fields Filters',
                filters: [
                    {
                        name: 'seed_rep'
                        display_name: 'Seed Rep'
                        class: 'dropup'
                    },
                    {
                        name: 'seed_company'
                        display_name: 'Seed Company'
                        class: 'dropup'
                    },
                    {
                        name: 'brands'
                        display_name: 'Brand'
                        class: 'dropup'
                    },
                    {
                        name: 'status'
                        display_name: 'Status'
                        class: 'dropup'
                        colors: [
                            { key: 'Not Started', color: 'red' },
                            { key: 'Incomplete', color: 'orange' },
                            { key: 'Complete', color: 'green' },
                        ],
                    },

                ]
            }
        ]

        @sidebar = new SidebarKo filters
        @filters = @sidebar
        #ko.cleanNode $(@layoutSelector)[0]
        ko.applyBindings @sidebar, $(@layoutSelector)[0]

        @keyfields_subHandler = @createSubHandler(@defaultSub)
        if @keyfields_subHandler
            @keyfields_subHandler.init(@modalInstance)

        @msg = $(@layoutSelector).find('.message_writer')

        $(@layoutSelector).find('.apply-filters').bind 'click', () =>
            @keyfields_subHandler.loader.init('Loading Key Fields...')
            @keyfields_subHandler.refreshReport()

        $(@layoutSelector).find('.report-applied-filters').undelegate().delegate '.applied-filter-header', 'click', () ->
            $(this).siblings('.applied-filter-value-container').slideToggle('fast')
            if $(this).find('.caret-arrow').hasClass('caret-right')
                $(this).find('.caret-arrow').removeClass('caret-right')
            else
                $(this).find('.caret-arrow').addClass('caret-right')
